import { SliceCaseReducers } from '@reduxjs/toolkit/src/createSlice';
import { TrainProgressProps } from '../../../types/reduxTypes/trainProgress';

const createReducer = <T extends SliceCaseReducers<TrainProgressProps>>(reducer: T) => ({ ...reducer });

const reducers = createReducer({
  setTrainProgressData(state, action) {
    state.trainProgressData = action.payload;
  }
});

export default reducers;
